var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"funding-view"},[_c('iframe',{ref:"fundingFrame",staticClass:"funding-content-frame",style:({ height: `${_vm.frameHeight}px` }),attrs:{"title":"LAFIA funding projects","src":_vm.frameSrc,"scrolling":"no"},on:{"load":_vm.syncFrameHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }